/** Optional future provider contracts. Voice V1 uses browser recognition and synthesis directly. */
export type CoreState = "IDLE" | "LISTENING" | "THINKING" | "ANSWERING" | "WARNING" | "DECISION_REQUIRED" | "OFFLINE" | "AI_OFFLINE" | "MISSING_DATA" | "ERROR";
export interface SpeechToTextProvider {
  transcribe(audio: Blob, options: { signal: AbortSignal; language: "de-DE" }): Promise<{ text: string }>;
}
export interface TextToSpeechProvider {
  synthesize(text: string, options: { signal: AbortSignal; language: "de-DE" }): Promise<Blob>;
}
export interface VoiceProvider {
  readonly id: string;
  readonly speechToText: SpeechToTextProvider;
  readonly textToSpeech: TextToSpeechProvider;
  connect(options: { signal: AbortSignal }): Promise<void>;
  disconnect(): Promise<void>;
}
export const coreLabels: Record<CoreState, string> = {
  IDLE: "Bereit", LISTENING: "Ich höre zu", THINKING: "Analysiere",
  ANSWERING: "Antwort bereit", WARNING: "Aufmerksamkeit erforderlich",
  AI_OFFLINE: "KI NICHT VERBUNDEN", MISSING_DATA: "FEHLENDE DATEN", ERROR: "FEHLER",
  DECISION_REQUIRED: "ENTSCHEIDUNG ERFORDERLICH", OFFLINE: "Voice Provider noch nicht verbunden",
};

export function assistantCoreState(status?: import("./assistant-core/contracts").AssistantStatus): CoreState {
  return status === "NOT_CONNECTED" ? "AI_OFFLINE" : status === "ERROR" ? "ERROR" : status === "MISSING_DATA" ? "MISSING_DATA" : status === "DECISION_REQUIRED" ? "DECISION_REQUIRED" : "ANSWERING";
}
